<mat-icon title="Geblockter Lieferant">block</mat-icon>

@if (showLabel()) {
  <span>Geblockter Lieferant</span>
}
